import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { translate } from '@haldor/ui';
import { Link } from 'react-router-dom';
import { getCourse, setActiveCourse } from 'actions/courses';
import { getSection, setActiveSection } from 'actions/sections';
import { setPageTitle } from 'actions/header';
import { addError } from 'actions';
import { createVerdict, getSectionVerdicts, getVerdictScale, updateVerdict, submitBulkVerdicts } from 'actions/verdicts';
import DateTime from '_class/DateTime';
import Modal from 'containers/Modals/Modal';
import VerdictWidget from 'containers/Verdict/Display/VerdictWidget';
import MultipleVerdictForm from 'containers/Verdict/Form/MultipleVerdictForm';
import VerdictForm from './Partials/VerdictForm';
import { Collapsible, DataList, Spinner, Person } from 'UI';
import RowItem, { RowCell } from 'UI/Elements/List/RowItem';
import { Button, Icon, Checkbox, TooltipMenu, Tabs, Tab } from '@haldor/ui';

var CourseProgress = /*#__PURE__*/function (_Component) {
  _inherits(CourseProgress, _Component);

  var _super = _createSuper(CourseProgress);

  /* Class setup */
  function CourseProgress(props) {
    var _this;

    _classCallCheck(this, CourseProgress);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var course;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (_this.props.scale == null) {
                _this.props.getVerdictScale();
              }

              _context.next = 3;
              return _this.props.getSection(_this.props.match.params.groupId);

            case 3:
              _context.next = 5;
              return _this.props.getCourse(_this.props.match.params.courseId);

            case 5:
              course = _this.props.course;

              _this.props.setPageTitle(course.title);

              _context.next = 9;
              return _this.props.getSectionVerdicts(_this.props.match.params.groupId, _this.props.match.params.courseId);

            case 9:
              _this.setState({
                loading: false
              });

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      _this.props.setActiveSection();

      _this.props.setActiveCourse();
    });

    _defineProperty(_assertThisInitialized(_this), "onStudentSelect", function (student) {
      var selectedStudents = _this.state.selectedStudents;

      var found = _this.state.selectedStudents.findIndex(function (selectedStudent) {
        return selectedStudent.id == student.id;
      });

      var verdicts = _this.props.sectionVerdicts.filter(function (verdict) {
        return verdict.status == 'VERDICT_DRAFT';
      });

      if (found == -1) {
        selectedStudents.push(student);
      } else {
        selectedStudents.splice(found, 1);
      }

      var studentsWithDrafts = _this.state.selectedStudents.filter(function (student) {
        return verdicts.find(function (verdict) {
          return verdict.userId == student.userId;
        }) == null;
      });

      var disableCreateVerdict = studentsWithDrafts.length < _this.state.selectedStudents.length;
      var disablePublishButton = studentsWithDrafts.length > 0;
      var disableCopyButton = studentsWithDrafts.length === 0;

      _this.setState({
        selectedStudents: selectedStudents,
        disableCreateVerdict: disableCreateVerdict,
        disablePublishButton: disablePublishButton,
        disableCopyButton: disableCopyButton
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleOpen", function (student, active) {
      var open = _this.state.open;

      var found = _this.state.open.indexOf(student.id);

      if (active && found == -1) {
        open.push(student.id);
      }

      if (!active && found > -1) {
        open.splice(found, 1);
      }

      _this.setState({
        open: open
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleOpenAll", function () {
      if (_this.state.open.length > 0) {
        _this.setState({
          open: []
        });
      } else {
        var group = _this.props.group;

        _this.setState({
          open: _toConsumableArray(group.students).map(function (student) {
            return student.id;
          })
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "toggleAllEntries", function (checked) {
      if (checked) {
        var verdicts = _this.props.sectionVerdicts.filter(function (verdict) {
          return verdict.status == 'VERDICT_DRAFT';
        });

        var studentsWithDrafts = _this.props.group.students.filter(function (student) {
          return verdicts.find(function (verdict) {
            return verdict.userId == student.userId;
          }) == null;
        });

        var disableCreateVerdict = studentsWithDrafts.length < _this.props.group.students.length;
        var disablePublishButton = studentsWithDrafts.length > 0;

        _this.setState({
          selectedStudents: _toConsumableArray(_this.props.group.students),
          markableStudentCount: _this.props.group.students.length,
          disableCreateVerdict: disableCreateVerdict,
          disablePublishButton: disablePublishButton
        });
      } else {
        _this.setState({
          selectedStudents: []
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onStudentClick", function (student) {
      _this.setState({
        activeStudent: student,
        duplicate: false,
        verdictModal: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "reload", function () {
      var course = _this.props.course;

      _this.props.getSectionVerdicts(_this.props.match.params.groupId, course.id);
    });

    _defineProperty(_assertThisInitialized(_this), "onDuplicateClick", function (student) {
      if (_this.props.sectionVerdicts != null) {
        var verdict = _this.props.sectionVerdicts.find(function (verdict) {
          return student.id == verdict.userId;
        });

        if (verdict != null) {
          _this.setState({
            duplicate: true,
            activeStudent: student
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "toggleVerdictModal", function () {
      _this.setState({
        verdictModal: !_this.state.verdictModal
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onMultipleVerdictPublish", function (values) {
      var course = _this.props.course;
      return new Promise(function (resolve) {
        values.forEach(function (value) {
          value.courses = [{
            "courseCode": course.courseCode,
            "subjectCode": course.subjectCode,
            "courseID": course.id
          }];
        });

        _this.props.submitBulkVerdicts(values).then(function () {
          _this.setState({
            multipleVerdicts: false
          });

          _this.postSubmit(resolve);
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "postSubmit", function (resolve) {
      var course = _this.props.course;
      var promises = [];
      promises.push(_this.props.getSectionVerdicts(_this.props.match.params.groupId, course.id));
      Promise.all(promises).then(function () {
        var date = _this.props.tenant.currentSchoolYear != null ? _this.props.tenant.currentSchoolYear : '2017-01-01';

        var verdicts = _this.props.sectionVerdicts.filter(function (verdict) {
          return verdict.status == 'VERDICT_DRAFT';
        });

        var studentsWithDrafts = _this.state.selectedStudents.filter(function (student) {
          return verdicts.find(function (verdict) {
            return verdict.userId == student.userId;
          }) == null;
        });

        var disableCreateVerdict = studentsWithDrafts.length < _this.state.selectedStudents.length;
        var disablePublishButton = studentsWithDrafts.length > 0;
        var disableCopyButton = studentsWithDrafts.length === 0;

        _this.setState({
          loading: false,
          disableCreateVerdict: disableCreateVerdict,
          disablePublishButton: disablePublishButton,
          disableCopyButton: disableCopyButton
        });

        if (resolve != null) {
          resolve(1);
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderStudentRow", function (student, index) {
      var _this$props$match$par = _this.props.match.params,
          groupId = _this$props$match$par.groupId,
          courseId = _this$props$match$par.courseId;
      var verdict = null;

      if (_this.props.sectionVerdicts != null) {
        verdict = _this.props.sectionVerdicts.find(function (verdict) {
          return student.id == verdict.userId;
        });
      }

      var open = false;

      if (_this.state.open.indexOf(student.id) > -1) {
        open = true;
      }

      var found = _this.state.selectedStudents.find(function (selectedStudent) {
        return selectedStudent.id == student.id;
      });

      var isDraft = verdict != null && verdict.status == 'VERDICT_DRAFT';
      var isPublished = verdict != null && verdict.status == 'VERDICT_PUBLISHED';
      var triggerButton = /*#__PURE__*/React.createElement(Button, {
        type: "secondary"
      }, "⋯");
      var collapsibleTrigger = /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex'
        }
      }, /*#__PURE__*/React.createElement("span", {
        style: {
          flex: 1
        }
      }, student.firstName, " ", student.lastName), verdict != null ? /*#__PURE__*/React.createElement(VerdictWidget, {
        verdict: verdict
      }) : null, verdict != null ? /*#__PURE__*/React.createElement("span", {
        style: {
          marginLeft: '.45rem'
        }
      }, new DateTime(isPublished ? verdict.published : verdict.created).getLongDate()) : null);
      var feedback = '';

      if (verdict != null && verdict.feedback != null) {
        feedback = verdict.feedback.replace(/(\r\n|\r|\n)/g, '<br />');
      }

      return /*#__PURE__*/React.createElement(RowItem, {
        key: index
      }, /*#__PURE__*/React.createElement(RowCell, {
        title: " ",
        shrink: true,
        style: {
          cursor: 'pointer'
        }
      }, /*#__PURE__*/React.createElement(Checkbox, {
        value: found != null,
        onChange: function onChange() {
          return _this.onStudentSelect(student);
        }
      })), /*#__PURE__*/React.createElement(RowCell, {
        title: "  "
      }, /*#__PURE__*/React.createElement(Collapsible, {
        open: open,
        onChange: function onChange(open) {
          return _this.toggleOpen(student, open);
        },
        trigger: collapsibleTrigger
      }, verdict != null ? /*#__PURE__*/React.createElement("div", {
        className: "verdict-feedback-row".concat(!open ? ' no-print' : '')
      }, verdict.createdBy != null ? /*#__PURE__*/React.createElement(Person, {
        style: {
          display: 'inline-flex'
        },
        person: verdict.createdBy
      }, /*#__PURE__*/React.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: feedback
        }
      })) : /*#__PURE__*/React.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: feedback
        }
      }), /*#__PURE__*/React.createElement(VerdictWidget, {
        verdict: verdict
      })) : null)), /*#__PURE__*/React.createElement(RowCell, {
        shrink: true
      }, isDraft ? /*#__PURE__*/React.createElement("span", {
        className: "draft-badge",
        style: {
          color: 'red'
        }
      }, _this.props.translate('Draft')) : null), /*#__PURE__*/React.createElement(RowCell, {
        shrink: true
      }, /*#__PURE__*/React.createElement(Link, {
        to: "/groups/".concat(groupId, "/course/").concat(courseId, "/student/").concat(student.id)
      }, /*#__PURE__*/React.createElement(Button, {
        type: "secondary"
      }, _this.props.translate('Show/Write verdict')))), /*#__PURE__*/React.createElement(RowCell, {
        shrink: true
      }, /*#__PURE__*/React.createElement(TooltipMenu, {
        trigger: triggerButton,
        id: student.id
      }, isPublished ? /*#__PURE__*/React.createElement(TooltipMenu.Item, {
        onClick: function onClick() {
          return _this.onDuplicateClick(student);
        }
      }, _this.props.translate('duplicate-previous-verdict')) : null, /*#__PURE__*/React.createElement(TooltipMenu.Item, null, /*#__PURE__*/React.createElement(Link, {
        to: "/groups/".concat(groupId, "/course/").concat(courseId, "/student/").concat(student.id)
      }, _this.props.translate('Show/Write verdict'))))));
    });

    _defineProperty(_assertThisInitialized(_this), "renderModals", function () {
      var _this$state = _this.state,
          activeStudent = _this$state.activeStudent,
          duplicate = _this$state.duplicate;
      var translate = _this.props.translate;
      if (activeStudent == null) return null;
      return /*#__PURE__*/React.createElement(Modal, {
        isOpen: _this.state.verdictModal,
        onClose: _this.toggleVerdictModal,
        title: translate('new-verdict') + " " + activeStudent.firstName + " " + activeStudent.lastName
      }, /*#__PURE__*/React.createElement(VerdictForm, {
        activeStudent: activeStudent,
        duplicate: duplicate,
        course: _this.props.course,
        group: _this.props.group,
        onClose: _this.toggleVerdictModal,
        reload: _this.reload
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "toggleMultipleVerdictForm", function () {
      _this.setState({
        multipleVerdicts: !_this.state.multipleVerdicts
      });
    });

    _defineProperty(_assertThisInitialized(_this), "copyPreviousVerdict", function () {
      var verdicts = _this.props.sectionVerdicts.filter(function (verdict) {
        var inSelected = _this.state.selectedStudents.find(function (student) {
          return student.id == verdict.userId;
        });

        if (verdict.status === "VERDICT_PUBLISHED" && inSelected != null) return verdict;
      });

      var promises = [];
      var values = [];
      verdicts.forEach(function (verdict) {
        var value = {
          courses: verdict.courses,
          feedback: verdict.feedback,
          scaleId: verdict.scaleId,
          scaleLevelId: verdict.scaleLevelId,
          status: 'VERDICT_DRAFT',
          userId: verdict.userId
        };
        values.push(value);
      });

      var promise = _this.onMultipleVerdictPublish(values);

      _this.setState({
        copyPreviousButtonIsLoading: true
      });

      promises.push(promise);
      Promise.all(promises).then(function () {
        _this.setState({
          selectedStudents: [],
          copyPreviousButtonIsLoading: false
        });

        _this.props.addError(_this.props.translate('verdict-copy-succeeded'), 'info');
      });
    });

    _defineProperty(_assertThisInitialized(_this), "publishVerdicts", function () {
      var verdicts = _this.props.sectionVerdicts.filter(function (verdict) {
        var inSelected = _this.state.selectedStudents.find(function (student) {
          return student.id == verdict.userId;
        });

        if (verdict.status == "VERDICT_DRAFT" && inSelected != null) return verdict;
      });

      var promises = [];
      verdicts.forEach(function (verdict) {
        verdict.status = 'VERDICT_PUBLISHED';

        var promise = _this.props.updateVerdict(verdict);

        promises.push(promise);
      });
      Promise.all(promises).then(function () {
        _this.postSubmit();

        _this.setState({
          selectedStudents: []
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderVerdictButton", function () {
      return /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        disabled: _this.state.selectedStudents.length == 0 || _this.state.disableCreateVerdict,
        onClick: _this.toggleMultipleVerdictForm
      }, _this.props.translate('new-verdict-for-selected'));
    });

    _defineProperty(_assertThisInitialized(_this), "renderPublishButton", function () {
      if (_this.props.sectionVerdicts != null && _this.props.sectionVerdicts.find(function (t) {
        return t.status == "VERDICT_DRAFT";
      }) != null) {
        return /*#__PURE__*/React.createElement(Button, {
          disabled: _this.state.selectedStudents.length == 0 || _this.state.disablePublishButton,
          onClick: _this.publishVerdicts
        }, _this.props.translate('publish-verdicts'));
      } else {
        return null;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderCopyPreviousVerdictButton", function () {
      if (_this.props.sectionVerdicts != null && _this.props.sectionVerdicts.find(function (t) {
        return t.status != "VERDICT_DRAFT";
      }) != null) {
        return /*#__PURE__*/React.createElement(Button, {
          type: "secondary",
          disabled: _this.state.selectedStudents.length == 0 || _this.state.disableCopyButton,
          onClick: _this.copyPreviousVerdict
        }, _this.state.copyPreviousButtonIsLoading ? /*#__PURE__*/React.createElement(Spinner, {
          center: true
        }) : null, _this.props.translate('copy-latest-verdicts'));
      } else {
        return null;
      }
    });

    _this.state = {
      activeStudent: null,
      verdictModal: false,
      loading: true,
      multipleVerdicts: false,
      editVerdict: 1,
      disableCreateVerdict: false,
      disableCopyButton: false,
      disablePublishButton: false,
      copyPreviousButtonIsLoading: false,
      selectedStudents: [],
      markableStudentCount: -1,
      open: []
    };
    return _this;
  }
  /* Lifecycle methods */


  _createClass(CourseProgress, [{
    key: "render",
    value: function render() {
      var _group$students;

      if (this.props.group == null || this.props.course == null) {
        return /*#__PURE__*/React.createElement(Spinner, {
          center: true
        });
      }

      var group = this.props.group;
      var open = this.state.open.length > 0;
      var students = [];

      if ((group === null || group === void 0 ? void 0 : (_group$students = group.students) === null || _group$students === void 0 ? void 0 : _group$students.length) > 0 && (group === null || group === void 0 ? void 0 : group.students) !== null) {
        var _group$students2;

        students = group === null || group === void 0 ? void 0 : (_group$students2 = group.students) === null || _group$students2 === void 0 ? void 0 : _group$students2.sort(function (a, b) {
          return a.lastName.localeCompare(b.lastName);
        });
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "progress single-task mentor-verdicts"
      }, this.renderModals(), /*#__PURE__*/React.createElement(Modal, {
        isOpen: this.state.multipleVerdicts,
        title: this.props.translate('new-verdict'),
        onClose: this.toggleMultipleVerdictForm
      }, /*#__PURE__*/React.createElement(MultipleVerdictForm, {
        onSubmit: this.onMultipleVerdictPublish,
        students: this.state.selectedStudents,
        onRemoveStudent: this.onStudentSelect,
        onAbort: this.toggleMultipleVerdictForm
      })), /*#__PURE__*/React.createElement("div", {
        className: "single-section left-side"
      }, /*#__PURE__*/React.createElement("div", {
        className: "single-assignment-meta"
      }, /*#__PURE__*/React.createElement(Link, {
        to: "/groups/".concat(this.props.group.id)
      }, this.props.translate('Go to group page for'), " ", this.props.group.title))), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      }), /*#__PURE__*/React.createElement(Tabs, null, /*#__PURE__*/React.createElement(Tab, {
        title: this.props.translate('verdicts'),
        route: "verdicts"
      }, this.state.loading ? /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "no-print",
        style: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }
      }, /*#__PURE__*/React.createElement("div", {
        onClick: this.toggleOpenAll,
        className: open ? "toggle-all flip color--meta" : "toggle-all color--meta"
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "ArrowLeft"
      }), open ? this.props.translate('Close all') : this.props.translate('Show all')), /*#__PURE__*/React.createElement("div", {
        style: {
          marginRight: '0.65rem'
        }
      }, /*#__PURE__*/React.createElement("div", {
        onClick: function onClick() {
          return window.print();
        },
        style: {
          cursor: 'pointer'
        },
        className: "color--meta"
      }, /*#__PURE__*/React.createElement("span", {
        style: {
          marginRight: '0.25rem',
          position: 'relative',
          top: 2
        }
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Printer"
      })), this.props.translate("print")))), /*#__PURE__*/React.createElement(DataList, {
        data: students,
        renderRow: this.renderStudentRow,
        toggleAllEntries: this.toggleAllEntries,
        allEntriesSelected: this.state.selectedStudents.length == this.state.markableStudentCount
      }), /*#__PURE__*/React.createElement("div", {
        className: "form-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row submit",
        style: {
          marginTop: '1.25rem',
          marginBottom: '1.25rem'
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "align-right"
      }, !this.props.group.archived ? this.renderCopyPreviousVerdictButton() : null, !this.props.group.archived ? this.renderVerdictButton() : null, !this.props.group.archived ? this.renderPublishButton() : null))))))), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      }));
    }
  }]);

  return CourseProgress;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    group: state.sections.activeSection,
    course: state.Courses.course,
    userVerdicts: state.Verdicts.user,
    scale: state.Verdicts.scale,
    sectionVerdicts: state.Verdicts.section,
    tenant: state.user.tenant,
    studentAdjustmentsByCourse: state.AdditionalAdjustments.studentAdjustmentsByCourse,
    studentAdjustmentsBySubject: state.AdditionalAdjustments.studentAdjustmentsBySubject
  };
}

export default connect(mapStateToProps, {
  getSection: getSection,
  setActiveSection: setActiveSection,
  getCourse: getCourse,
  setActiveCourse: setActiveCourse,
  createVerdict: createVerdict,
  getVerdictScale: getVerdictScale,
  getSectionVerdicts: getSectionVerdicts,
  updateVerdict: updateVerdict,
  addError: addError,
  setPageTitle: setPageTitle,
  submitBulkVerdicts: submitBulkVerdicts
})(CourseProgress);